/**
 * Seeded games for `VITE_USE_MOCK_DATA=true` — the reference CRUD entity.
 *
 * `name` and `description` are JSON *strings*, and `image.url` is
 * root-relative, because that is exactly what `GameResource` emits. Keeping the
 * awkward shapes here is the point: mock mode should exercise
 * `readTranslatable`/`resolveMediaUrl` the same way production does.
 */

import type { GameResponse } from "@shared/contracts";

const image = (slug: string) => ({
  url: `/storage/games/mock-${slug}/cover.png`,
  size: 12,
  extension: "png",
  mime_type: "image/png",
  storage_path: `public/games/mock-${slug}/cover.png`,
});

export const mockGames: GameResponse[] = [
  {
    id: 1,
    name: '{"en":"Spring Tournament"}',
    slug: "spring-tournament",
    description: '{"en":"The opening fixture of the season."}',
    image: image("spring-tournament"),
  },
  {
    id: 2,
    name: '{"en":"Summer League"}',
    slug: "summer-league",
    description: '{"en":"Twelve weeks of group-stage play."}',
    image: image("summer-league"),
  },
  {
    id: 3,
    name: '{"en":"Autumn Cup"}',
    slug: "autumn-cup",
    description: null,
    image: image("autumn-cup"),
  },
];
